$(function () {
    let count = $(".list-box").length,
    NumberListLen = [],
    DefaultNum = [],
    AddNum = [],
    CurrentNum = []

    for(let i = 2 ; i <= count ; i++){
      NumberListLen[i] = $(`.list-box:nth-of-type(${i}) .stamped-review-link-photo`).length;
      DefaultNum[i] = 4;
      AddNum[i] = NumberListLen[i] - DefaultNum[i];
      CurrentNum[i] = 0;

      if(NumberListLen[i] <= DefaultNum[i]){
        $(`.list-box:nth-of-type(${i}) .more_btn`).hide();
      }else{
        $(`.list-box:nth-of-type(${i}) .list-blog`).each(function () {
          $(`.list-box:nth-of-type(${i}) .more_btn`).show();
    
          $(`.list-box:nth-of-type(${i}) .stamped-review-link-photo:not(:lt(${DefaultNum[i]}))`).hide();
    
          CurrentNum[i] = DefaultNum[i];
  
          $(`.list-box:nth-of-type(${i}) .more_btn`).click(function () {
            CurrentNum[i] += AddNum[i];
            $(`.list-box:nth-of-type(${i}) .stamped-review-link-photo:lt(${CurrentNum[i]})`)
              .fadeIn();
    
            if (NumberListLen[i] <= CurrentNum[i]) {
              CurrentNum[i] = DefaultNum[i];
              indexNum = CurrentNum[i] - 1;
    
              $(`.list-box:nth-of-type(${i}) .more_btn`).hide();
            }
          });
        });
      }
    }
	
  });